import { createAsyncThunk } from "@reduxjs/toolkit";
import cuid from "cuid";
import axiosAPI from "../../services/axios";
import { GET_EVENT_FEEDBACK_METRICS } from "../../services/endpoints";

export const getEventFeedbackMetrics = createAsyncThunk(
  "event/feedbackMetrics",
  async (eventId: string, { rejectWithValue }) => {
    if (!cuid.isCuid(eventId)) {
      return rejectWithValue("Invalid eventId");
    }

    try {
      const { data } = await axiosAPI.request({
        url: GET_EVENT_FEEDBACK_METRICS(eventId),
        method: "GET",
      });
      return data;
    } catch (error: any) {
      if (error.response?.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);
